module.exports = __webpack_public_path__ + "static/media/amitCv.e96ef2ec.pdf";